/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Filter_In_StockInputs */

const vi_report_inventory_filter_in_stock = /** @type {(inputs: Report_Inventory_Filter_In_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn hàng`)
};

/**

* @param {Report_Inventory_Filter_In_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_filter_in_stock = /** @type {((inputs?: Report_Inventory_Filter_In_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Filter_In_StockInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_filter_in_stock(inputs)
});